<template>
  <div>
    <v-card class="mx-auto">
      <v-card-title class="indigo white--text text-h6">
        {{ $t("_menu.categoryGroup") }}
      </v-card-title>
      <v-treeview
        v-model="selected"
        shaped
        hoverable
        activatable
        :items="items"
      >
        <template v-slot:label="{ item }">
          <span :style="{ color: rowColor(item) }">{{ item.name }}</span>
          <v-tooltip top>
            <template v-slot:activator="{ on: ontooltip }">
              <v-btn icon v-on="{ ...ontooltip }">
                <v-icon small v-if="!item.isVisible" color="purple">
                  mdi-eye-off
                </v-icon>
                <v-icon
                  small
                  v-else
                  color="purple"
                >
                mdi-eye
                </v-icon></v-btn
              >
            </template>
            <span v-if="!item.isVisible">{{ $t("actions.unvisible") }}</span>
            <span v-else>{{ $t("actions.visible") }}</span>

          </v-tooltip>
        </template>
        <template v-slot:prepend="{ item }">
          <v-icon v-if="!item.icon">
            {{ "trending_flat" }}
          </v-icon>
          <v-icon v-else>
            {{ item.icon }}
          </v-icon>
        </template>
        <template v-slot:append="{ item }">
          <!-- v-if="item.parentCategoryId && item.children.length" to purge -->
          <!-- <v-icon v-if="item.parentCategoryId"
                small class="mr-2" 
                @click="addField(item)" 
                color="blue">
            {{ "settings" }}
          </v-icon> -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon small @click="editCategory(item)" color="green">
                  {{ "edit" }}
                </v-icon></v-btn
              >
            </template>
            <span>{{ $t("actions.edit") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon small @click="deleteCategory(item)" color="error">
                  {{ "delete" }}
                </v-icon></v-btn
              >
            </template>
            <span>{{ $t("actions.delete") }}</span>
          </v-tooltip>
        </template>
      </v-treeview>
    </v-card>
    <new-group-button
      :dialog.sync="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      :checkboxEnabled="checkboxEnabled"
      @cancelled="onCancelled"
    />
    <extra-field
      :dialog.sync="fieldDialog"
      @closed="onClosed"
      @fieldsChanged="refreshFieldTable"
      :editedItem="editedItem"
    />

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NewGroupButton from "./NewCategoryGroupButton";
import ExtraField from "./ExtraField.vue";
export default {
  components: { NewGroupButton, ExtraField },

  props: {
    value: Object,
  },
  data: () => ({
    selected: null,
    groups: [],
    totalCount: 0,
    loading: false,
    snackbar: false,
    snackColor: "",
    snackText: "",
    timeout: 3000,
    x: "",
    y: "",
    editedIndex: -1,
    editedItem: {
      id: null,
      name: null,
      icon: null,
      parentCategoryId: null,
      isVisible: null,
    },
    dialog: false,
    checkboxEnabled: false,
    mode: "",
    fieldDialog: false,
  }),
  mounted() {
    console.log("categories are refreshing due to mounting");
    //this.refreshTable();
  },

  computed: {
    ...mapGetters({ items: "category_tree/items" }),
    ...mapGetters({ dark: "app/dark" }),
  },
  methods: {
    ...mapActions(["category_tree/getItems"]),
    ...mapActions({ removeCategory: "category_groups/removeCategory" }),
    ...mapActions({ getExtraFields: "category/getExtraFields" }),

    async refreshTable() {
      console.log("cat group table refresh");
      this.loading = true;
      this.selected = 0;
      await this.$store.dispatch("category_tree/getItems");
      this.loading = false;
    },

    async deleteCategory(item) {
      var self = this;
      self.loading = true;
      self
        .$swal({
          title: "Kategoriyi silmek istediğinizden emin misiniz ?",
          text: "Altındaki tüm kategorilerle birlikte silinecektir.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "Vazgeç",
          confirmButtonColor: "#ff7674",
          cancelButtonColor: "#41b882",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        })
        .then(async function (isConfirm) {
          if (isConfirm.value) {
            self.loading = true;
            try {
              await self.removeCategory({
                item: item,
              });

              await self.refreshTable();
              self.snackbar = true;
              self.snackColor = "success";
              self.snackText = "Kategori silindi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;
            } catch (e) {
              self.snackbar = true;
              self.snackColor = "error";
              self.snackText = "Kategori silinemedi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;

              console.error(e);
            }
          } else {
            self.loading = false;
          }
        });
    },

    async editCategory(item) {
      console.log("this.items: ", this.items);
      console.log("itemmmmmmmmm", item);
      this.editedIndex = this.items.indexOf(item) + 1;
      console.log("editedIndex", this.editedIndex);
      this.editedItem = Object.assign({}, item);
      console.log("editedItem", this.editedItem);
      if (this.editedItem.parentCategoryId != null) {
        this.checkboxEnabled = true;
      } else {
        this.checkboxEnabled = false;
      }
      this.dialog = true;
    },
    async addField(item) {
      console.log(item);
      this.fieldDialog = true;
      this.editedIndex = this.items.indexOf(item) + 1;
      this.editedItem = Object.assign({}, item);
      console.log("Toggled Field Dialog", this.fieldDialog);
    },
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    onClosed() {
      // hide a dialog
      this.fieldDialog = false;
      console.log(this.fieldDialog);
    },
    refreshFieldTable() {
      this.refreshTable(); // TODO: Only refresh the required part
      console.log("refreshFieldTable called");
      console.log(this.editedItem);
      this.editedItem.categoryExtraField = this.getExtraFields(
        this.editedItem.id
      );
      console.log(this.editedItem);
      console.log("refreshFieldTable exit");
    },
    rowColor(item) {
      console.log(" visible", item);
      if (!item.isVisible) {
        return "#FD0505";
      } else {
        return this.dark ? "white" : "black";
      }
    },
  },
  watch: {
    selected() {
      console.log("selected", this.selected);
      console.log("selected item", this.items[this.selected]);
      this.$emit("update:value", this.items[this.selected]);
    },
  },
};
</script>